import ReactDOMServer from "react-dom/server"
import Swal from "sweetalert2"
import "./styles.css"

export const LoadingAlert = ({ show }: { show: boolean }) => {
  if (show) {
    return Swal.fire({
      width: "30%",
      heightAuto: false,
      html: ReactDOMServer.renderToString(
        <div
        className="flex justify-center items-center m-10"
        style={{ height: "150px", alignContent: "center" }}
      >
        <svg className="loading-svg"></svg>
      </div>
      
      ),
      allowOutsideClick: false,
      showConfirmButton: false,
    })
  } else {
    Swal.close()
  }
}
